// Cars
export const selectCars = state => state.infos.cars;

// Personnel
export const selectPersonnel = state => state.infos.personnel;

// RoadType
export const selectRoadType = state => state.infos.roadType;

// Routes
export const selectRoutes = state => state.infos.routes;

// Loading
export const selectIsLoading = state => state.infos.isLoading;

// Error
export const selectError = state => state.infos.error;
